<ng-container *ngIf="!inEdit">
    <div style="height: 320px; overflow-y: auto;" cdkDropList (cdkDropListDropped)="drop($event)">
        <div *ngFor="let item of helpVideos; let i = index" class="list-item d-flex align-items-center px-3 py-2" cdkDrag cdkDragPreviewContainer="parent" cdkDragBoundary=".k-dialog-content">
            <i class="mdi-editor-drag-handle grey-text font-size-1-3 mr-2 cursor-move"></i>
            <span class="flex-grow-1 cursor-pointer" (click)="startEdit(item)">
                {{ item.title }}
            </span>
            <!-- <i class="mdi-hardware-keyboard-arrow-up cursor-pointer grey-text font-size-1-3 mr-1" [class.disabled-icon]="i === 0" (click)="moveUp(i)"></i>
            <i class="mdi-hardware-keyboard-arrow-down cursor-pointer grey-text font-size-1-3 mr-2" [class.disabled-icon]="i === helpVideos.length - 1" (click)="moveDown(i)"></i> -->
            <i class="mdi-action-delete cursor-pointer pink-text font-size-1-3" (click)="deleteItem(i)"></i>
        </div>
        <div *ngIf="helpVideos.length === 0" class="px-3 py-2 grey-text text-darken-2">
            Niciun tutorial adăugat.
        </div>
    </div>
    <button class="col-auto py-2 border-0 text-left add-line-btn" (click)="addItem()">
        <i class="mdi-content-add mr-2"></i>
        <span i18n="@@Actions$AddNewLine">Adaugă</span>
    </button>
    <div class="d-flex justify-content-around align-items-center pt-3 pb-2">
        <button class="btn waves-effect waves-light" type="button" name="action" i18n="@@Actions$Save" (click)="saveAll()">
            Salvează
        </button>
        <button class="btn waves-effect waves-light" type="button" name="action" i18n="@@Actions$Cancel" (click)="cancel.emit()">
            Renunță
        </button>
    </div>
</ng-container>

<ng-container *ngIf="inEdit">
    <div class="px-3 pt-3" style="height: 360px; overflow-y: auto;">
        <kee-dropdown label="Tip" [data]="videoTypes" textField="text" valueField="value" [valuePrimitive]="true" [(ngModel)]="editingItem.type"></kee-dropdown>
        <inputfield label="Titlu" [(ngModel)]="editingItem.title"></inputfield>
        <inputfield *ngIf="editingItem.type === 'youtube'" label="URL" [(ngModel)]="editingItem.url"></inputfield>
        <kee-textarea *ngIf="editingItem.type === 'content'" label="Content" [(ngModel)]="editingItem.content" rows="3"></kee-textarea>
        <inputfield label="Link conținut complet" [(ngModel)]="editingItem.full_content_link"></inputfield>
        <div class="d-flex align-items-center pt-2">
            <input type="file" accept="image/*" class="d-none" #thumbInput (change)="onThumbnailSelect($event, editingItem)" />
            <button type="button" class="col-auto px-0 py-2 border-0 text-left add-line-btn" (click)="thumbInput.click()">
                <i class="mdi-content-add mr-2"></i>Selectează imagine (thumbnail: 110 x 62)
            </button>
            <img *ngIf="editingItem.thumbnail" class="video-thumbnail ml-3" [src]="editingItem.thumbnail"/>
        </div>
    </div>
    <div class="d-flex justify-content-around align-items-center pt-3 pb-2">
        <button class="btn waves-effect waves-light" type="button" name="action" (click)="saveItemEdit()">
            {{ editingIndex === -1 ? 'Adaugă' : 'Modifică' }}
        </button>
        <button class="btn waves-effect waves-light" type="button" name="action" i18n="@@Actions$Cancel" (click)="cancelItemEdit()">
            Înapoi
        </button>
    </div>
</ng-container>
